import { useEffect, useState } from "react";
import { Smartphone, Share, PlusSquare } from "lucide-react";
import { Button } from "@/components/ui/button";

const standalone = () => window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone;
const isIos = () => /iphone|ipad|ipod/i.test(window.navigator.userAgent);

export const InstallApp = () => {
  const [prompt, setPrompt] = useState(window.__installPrompt || null);
  const [installed, setInstalled] = useState(standalone());
  useEffect(() => {
    const ready = () => setPrompt(window.__installPrompt);
    const done = () => setInstalled(true);
    window.addEventListener("clockaroo-installable", ready);
    window.addEventListener("appinstalled", done);
    return () => { window.removeEventListener("clockaroo-installable", ready); window.removeEventListener("appinstalled", done); };
  }, []);
  if (installed) return null;
  const install = async () => {
    prompt.prompt();
    await prompt.userChoice;
    window.__installPrompt = null;
    setPrompt(null);
  };
  return (
    <div className="flex flex-col gap-4 rounded-2xl bg-[#0B2A5B] p-5 text-white sm:flex-row sm:items-center" data-testid="install-app-card">
      <span className="grid h-12 w-12 shrink-0 place-items-center rounded-2xl bg-white/10"><Smartphone className="h-6 w-6 text-amber-300" /></span>
      <div className="flex-1">
        <p className="font-semibold">Get the Clockaroo app on your phone</p>
        {prompt ? <p className="text-sm text-white/70">Install it to your home screen for one-tap clock in.</p>
          : isIos() ? <p className="flex flex-wrap items-center gap-1 text-sm text-white/70">In Safari tap <Share className="h-4 w-4" /> Share, then <PlusSquare className="h-4 w-4" /> Add to Home Screen.</p>
            : <p className="text-sm text-white/70">Open {window.location.host} in Chrome on your phone, tap the ⋮ menu, then "Install app" or "Add to Home screen".</p>}
      </div>
      {prompt && <Button onClick={install} className="rounded-full bg-[#FF8A00] font-bold text-[#0B2A5B] hover:bg-amber-400" data-testid="install-app-btn">Install app</Button>}
    </div>
  );
};
